import React from 'react';
import './index.scss';

//material-ui
import { CircularProgress, Paper } from '@material-ui/core';

//api
import {api} from '../../functions/api';


//other libraries

import { inject, observer } from 'mobx-react';

import ReactHtmlParser from 'react-html-parser';
import {isMobileSafari} from 'react-device-detect';

import Icon from '@mdi/react'
import { mdiFileDocument } from '@mdi/js'


@inject('internal')
@inject('translate')
@observer
export default class Static extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            content: "",
            slug: "",
            error: false,
            isIOS: false,
            files: null
        }
    }

    componentDidMount() {
        this.props.internal.setRoute( this.props.history, this.props.location.pathname)
        if(this.props.match.params.page) {
            this.setState({slug: this.props.match.params.page})
            this.loadStaticTemplate()
        }
        if(isMobileSafari) {
            this.setState({isIOS: true})
        }
    }

    componentWillReceiveProps() {
        if(this.props.match.params.page !== this.state.slug) {
            this.setState({slug: this.props.match.params.page})
            this.loadStaticTemplate()
        }
    }

    loadStaticTemplate = async() => {
        this.setState({loading: true})
        let slug = this.props.match.params.page
        let load_data = await api({
            method: 'GET',
            url: `pages/${slug}`,
            authorization: this.props.internal.user.access_token,
        })

        if(load_data.success === true){
            this.props.internal.setHeaderTitle(load_data.data.data.title)
            this.setState({loading: false, content: load_data.data.data.content, files:load_data.data.data.files,  error: false})
        }
        else {
            if(load_data.status === undefined && load_data.error === undefined) {
                this.setState({loading: false, content: this.props.translate.i18n.GLOBAL.ALERTS.LOAD_ERROR,  error: true})
            }
            else {
                this.setState({loading: false})
            }
            
        }
    }
    

    render() {
        return (
            this.state.loading ?
                <CircularProgress className={'circular-progress'} />
                :
                <div  className={`static-page-container ${this.state.isIOS ? "ios" : ""}`}>
                    
                    <Paper className={'static-page-content'}>
                        {!this.state.error
                            ?
                            ReactHtmlParser(this.state.content)
                            :
                            <div style={{textAlign: "center"}}>{this.state.content}</div>
                        }
                        {this.state.files !== null && this.state.files.length > 0 && <hr className={'divider'}/>}
                        {this.state.files !== null && this.state.files.length > 0 ?
                            <div className={'listDocs'}>
                                <p className={"titleDocuments"}>{this.props.translate.i18n.MODULES.STATIC_PAGES.DOCUMENTS}</p>
                                <div className={'docsConainer'}>
                                {this.state.files.map((file, index) => {
                                    return (
                                        <a href={file.download} target="_blank" key={index} className={'oneDocContainer'}>
                                            <Icon path={mdiFileDocument} size={2}  />
                                            <span>{file.filename}</span>
                                        </a>
                                    )
                                })}
                                </div>
                            </div>
                            :
                            null
                        }
                    </Paper>
                    
                </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/static/index.js